document.addEventListener('DOMContentLoaded', () => {
  const initAnimate = (root = document) => {
    const elements = root.querySelectorAll('[data-animate]');
    
    if (elements.length === 0) return;

    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    const observerOptions = {
      root: null,
      rootMargin: isMobile ? '0px 0px 50px 0px' : '0px',
      threshold: isMobile ? 0.05 : 0.15
    };

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const delay = el.getAttribute('data-animate-delay');
          
          if (delay) {
            el.style.transitionDelay = `${delay}s`;
          }
          
          requestAnimationFrame(() => {
            el.classList.add('is-visible');
          });

          obs.unobserve(el);
        }
      });
    }, observerOptions);

    elements.forEach(el => {
      observer.observe(el);
    });
  };

  initAnimate();

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => initAnimate(e.target));
  }
});